import { render, staticRenderFns } from "./NewsletterSendDialog.vue?vue&type=template&id=0544b02e"
import script from "./NewsletterSendDialog.vue?vue&type=script&lang=js"
export * from "./NewsletterSendDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports